import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { PerkService } from '../perk/perk.service';
import { UserService } from '../user/user.service';
import { User, WelcomeGiftStepState } from 'src/app/interfaces/user';

@Injectable({
  providedIn: 'root'
})
export class PetplanEligiblePetsResolverService  {

  constructor(
    private perkService: PerkService,
    private router: Router,
    private userService: UserService,
  ) {}

  private updateUserDetails(): Observable<User> {
    const userChanges: Partial<User> = {
      welcomeGiftStepCompleted: WelcomeGiftStepState.Updated
    };

    return this.userService.patchMe(userChanges);
  }

  resolve(): Observable<any> {
    return this.updateUserDetails().pipe(
      switchMap(() => this.perkService.getPetplanEligiblePets()),
      tap(pets => {
        if (pets.length) {
          this.router.navigate(['/dashboard'], { queryParams: { followUs: 'open' } });
        }
      })
    );
  }
}
